import React from 'react';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import MedicalReportDetailSerbiaForm from './MedicalReportDetailSerbiaForm';

interface Props {
	onSuccess: (values: FormValues) => void;
	defaultData?: any;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	disableSubmit?: boolean;
}

const MedicalReportDetailSerbia: React.FC<Props> = ({
	onSuccess,
	defaultData,
	disableSubmit,
	patientId,
}) => {
	return (
		<MedicalReportDetailSerbiaForm
			onSubmit={onSuccess}
			defaultData={defaultData}
			disableSubmit={disableSubmit}
			patientId={patientId}
		/>
	);
};

export default MedicalReportDetailSerbia;
